import React from "react";
import { graphql, useStaticQuery, Link } from "gatsby"
import { Menu } from "antd";
// import Link from "gatsby"

const TopNav = () => {
  const { SubMenu } = Menu;
  const data = useStaticQuery(graphql`
      query TopNavQuery {

        allPage {

          nodes {
            name
            slug
            publish
          }

        }

        allResources(sort: {fields: position, order: ASC}) {

          nodes {
            name
            position
            redirect
            resource_links {
              name
              url
            }
          }

        }

      }
  `)
  return (
    <>
      <Menu
        //onClick={this.handleClick}
        //selectedKeys={[current]}
        mode="horizontal"
      >
        {data.allResources.nodes.map(items => (

          <SubMenu
          key={items.position}
          //title={items.name}
          title={items.redirect !== null ? <Link to={items.redirect}>{items.name}</Link> : items.name}
          >
            <div className="SubMenu">
              {items.resource_links.map(items => (
                <Menu.Item key={items.name.replace(/\s+/g, "-").toLowerCase()}>
                  {items.url.indexOf('http') > -1 ?
                    <a class="textLink" href={items.url} target="_blank" rel="noopener">{items.name}</a>
                  :
                    <Link class="textLink" to={items.url}>{items.name}</Link>
                  }
                </Menu.Item>
              ))}
            </div>
          </SubMenu>

        ))}
        <Menu.Item key="council">
            <Link class="textLink" to="/council">The Chofly Council</Link>
        </Menu.Item>
        <Menu.Item key="contact">
            <Link class="textLink" to="/contact">Contact</Link>
        </Menu.Item>
      </Menu>
    </>
  )
}

export default TopNav

